var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        id: "pdf-modal",
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": true,
        "min-width": _vm.minWidth,
      },
      on: {
        "update:active": [
          function ($event) {
            _vm.isActive = $event
          },
          function ($event) {
            return _vm.close()
          },
        ],
      },
    },
    [
      _c("div", { staticClass: "box" }, [
        _c("article", { staticClass: "media" }, [
          _c("div", { staticClass: "media-content" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.title
                  ? _c("h4", { staticClass: "title is-5" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ])
                  : _vm._e(),
                _c("bulma-carousel", {
                  attrs: {
                    image: _vm.image,
                    "image-width": _vm.imageWidth,
                    "image-height": _vm.imageHeight,
                    "image-ids": _vm.imageIds,
                    "start-index": _vm.startIndex,
                  },
                  on: { orientation: _vm.setOrientation },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }